<template>
  <b-container v-if="modifier">
    <b-row class="mb-2">
      <b-col>
        <h1>Create Modifier Group</h1>
      </b-col>
      <b-col>
        <b-button
          variant="primary"
          class="float-right"
          @click="$router.push('/modifiers')"
        >
          Back
        </b-button>
      </b-col>
    </b-row>
    <b-overlay :show="loading" no-wrap fixed />
    <b-row v-if="Object.keys(errors).length">
      <b-col class="mb-2" sm="12" lg="6">
        <error-alert :errors="errors" />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" lg="6">
        <b-form class="base-form-col" @submit.prevent="onCreate">
          <b-form-group label="Name">
            <b-form-input v-model="modifier.name" />
          </b-form-group>
          <b-form-group label="Import Key">
            <b-form-input v-model="modifier.import_key" />
          </b-form-group>
          <b-form-group label="Type">
            <b-form-select v-model="modifier.type" :options="typeOptions" />
          </b-form-group>
          <custom-search-field
            v-model="modifier.brand"
            group-label="Brand"
            :path-to-search="'brands'"
          />
          <b-button variant="primary" type="submit">Create</b-button>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Modifier from '../../models/Modifier';

export default {
  data() {
    return {
      modifier: null,
      errors: {},
      loading: false,
      typeOptions: [
        {
          value: 'select',
          text: 'Select one',
        },
        {
          value: 'multi-select',
          text: 'Select many',
        },
      ],
    };
  },
  mounted() {
    this.modifier = new Modifier();
  },
  methods: {
    onCreate() {
      const me = this;

      me.modifier.set(
        'brand_id',
        me.modifier.brand ? me.modifier.brand.id : null
      );

      me.modifier
        .save()
        .then((response) => {
          const data = response.getData();

          me.$router.push({
            name: 'modifier',
            params: {
              id: data.id,
            },
          });
        })
        .catch((error) => {
          me.errors = error.response.data.errors;
        });
    },
  },
};
</script>
